import { ActionTypes } from 'constants/index';

export const saveJob = (data) => dispatch => {
    dispatch({ type: ActionTypes.SAVE_JOB, payload: data });
};

export const getJob = (data) => dispatch => {
    dispatch({ type: ActionTypes.GET_JOB, payload: data });
};

export const executeJob = (data) => dispatch => {
    dispatch({ type: ActionTypes.EXECUTE_JOB, payload: data });
};

export const clearReduxDataOfComponentInJobStore = (data) => dispatch => {
    dispatch({ type: ActionTypes.CLEAR_REDUX_DATA_OF_COMPONENT_IN_JOB_STORE, payload: data });
};